export default __webpack_public_path__ + "static/media/nissan.877ec25a.webp";